import React from "react";
import { Link } from "react-router-dom";

const MobileNavBar = () => {
  return (
    <section className="w-full px-5 ">
      <ul className="bg-secondary text-primary rounded-md flex flex-col gap-6 w-full justify-center items-start p-5 list-none">
        <li className="font-normal text-[20px]">
          <a href="#home">Home</a>
        </li>
        <li className="font-normal text-[20px]">
          <a href="#aboutus">About Us</a>
        </li>
        <li className="font-normal text-[20px]">
          <a href="#subjects">Topics</a>
        </li>
        <li className="font-normal text-[20px]">
          <a href="#contactus">Contact Us</a>
        </li>
        <li className="w-full">
          <Link to="/login">
            <button className="bg-primary text-secondary font-bold text-[16px] rounded-md h-[36px] w-full">
              Login
            </button>
          </Link>
        </li>
        <li className="w-full">
          <Link to="/register">
            <button className="bg-primary text-secondary font-bold text-[16px] rounded-md h-[36px] w-full">
              Register
            </button>
          </Link>
        </li>
      </ul>
      <div className=""></div>
    </section>
  );
};

export default MobileNavBar;
